
import { MultipleAnswerQuestion } from '@/types/Quiz'
import BlueButton from '@/components/Buttons/BlueButton.vue'
import { defineComponent, PropType, ref } from 'vue'

export default defineComponent({
  name: 'Question',
  components: { BlueButton },
  props: {
    question: {
      type: Object as PropType<MultipleAnswerQuestion>,
      required: true,
    },
    onSelect: {
      type: Function,
      required: true,
    },
    showResults: {
      type: Boolean,
    },
  },
  setup() {
    const context = ref(false)

    return {
      context,
    }
  },
})
